import React, { useState } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LandingPageUpdated = ({ onStartConfiguration, onLoadConfiguration }) => {
  const [codeInput, setCodeInput] = useState('');
  const [codeStatus, setCodeStatus] = useState({ state: 'idle', message: '' });

  const handleLoadCode = async () => {
    const code = codeInput.trim();
    if (!code) return;
    setCodeStatus({ state: 'loading', message: '' });
    try {
      const response = await fetch(`${BACKEND_URL}/api/configurations/${encodeURIComponent(code)}`);
      if (response.ok) {
        const data = await response.json();
        setCodeStatus({ state: 'idle', message: '' });
        onLoadConfiguration(data);
      } else {
        setCodeStatus({ state: 'error', message: 'Konfigurationscode nicht gefunden. Bitte prüfen Sie Ihre Eingabe.' });
      }
    } catch (error) {
      setCodeStatus({ state: 'error', message: 'Verbindungsfehler. Bitte versuchen Sie es erneut.' });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md text-center bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl px-8 py-10" data-testid="minimal-landing">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-2">
          Xortec Kameramast-Konfigurator
        </h1>
        <p className="text-slate-600 mb-8">
          Stellen Sie Ihren Kameramast inklusive Zubehör in wenigen Schritten zusammen.
        </p>

        <button
          onClick={onStartConfiguration}
          className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 text-base font-semibold text-white bg-blue-700 hover:bg-blue-800 rounded-lg transition-colors mb-8"
          data-testid="hero-configure-btn"
        >
          Jetzt konfigurieren
          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </button>

        <div className="border-t border-slate-200 pt-6" data-testid="config-code-load-panel">
          <p className="text-sm font-medium text-slate-700 mb-3">
            Sie haben bereits einen Konfigurationscode?
          </p>
          <div className="flex gap-2">
            <input
              type="text"
              value={codeInput}
              onChange={(e) => { setCodeInput(e.target.value.toUpperCase()); setCodeStatus({ state: 'idle', message: '' }); }}
              onKeyDown={(e) => e.key === 'Enter' && handleLoadCode()}
              placeholder="z.B. XOR-A7B3K9"
              className="flex-1 px-3 py-2.5 border border-slate-300 rounded-lg font-mono tracking-wider text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
              data-testid="config-code-input"
            />
            <button
              onClick={handleLoadCode}
              disabled={codeStatus.state === 'loading' || !codeInput.trim()}
              className="px-5 py-2.5 font-semibold text-white bg-blue-700 hover:bg-blue-800 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              data-testid="config-code-load-btn"
            >
              {codeStatus.state === 'loading' ? 'Lädt…' : 'Laden'}
            </button>
          </div>
          {codeStatus.state === 'error' && (
            <p className="text-red-600 text-xs mt-2 text-left" data-testid="config-code-error">
              {codeStatus.message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default LandingPageUpdated;
